import React, { memo, useMemo } from "react";
import PT from "prop-types";
import * as S from "./styled";
import CroppedText from "_c/CroppedText";
import { normalizeRating } from "@/utils";
import { PREMIUM_ICON_URL, IS_BROWSER } from "@/misc/constants";
import { scrollTo } from "@/utils/scroller";
import PhoneIcon from "_c/icon/Phone";
import { Button } from "_c/button";
// import ClockIcon from "_c/icon/Clock";
import Bio from "../Bio";
import { useToggle } from "@/hooks/useToggle";

const Details = ({ t, ...props }) => {
  const showMeta = props.pageType !== "client";
  const [isPhoneHidden, showPhone] = useToggle(props.hidePhoneUnderButton);
  const onRateClick = () => {
    if (IS_BROWSER && props.reviewsCount > 0) {
      scrollTo("#profile-feedback-container");
    }
  };
  return (
    <S.Wrap>
      {/*props.pageType === "master" && (
        <Button
          css={`
            margin-top: 10px;
          `}
          small
          greenish
          withIcon
          onClick={props.openFreeSlots}
        >
          <ClockIcon width="16" color="currentColor" />
          <span>{t("common:task_editor.free_slots")}</span>
        </Button>
      )*/}
      {showMeta && (
        <S.ReviewsSect>
          {props.isPremium && <img src={PREMIUM_ICON_URL} />}
          {props.reviewsCount > 0 && (
            <>
              <S.Average>{normalizeRating(props.rate)}</S.Average>
              <S.Count role="button" onClick={onRateClick}>
                {props.reviewsCount +
                  " " +
                  t("common:review", { count: props.reviewsCount })}
              </S.Count>
            </>
          )}
        </S.ReviewsSect>
      )}
      <div>
        {showMeta && props.address && (
          <S.Location>
            <S.Address>{props.address}</S.Address>
          </S.Location>
        )}
        {props.pageType === "master" && props.showPhone && props.phone && (
          <div
            css={`
              margin-top: 10px;
              color: var(--color-cta);
              display: flex;
              align-items: center;
              a {
                font-weight: 500;
                color: var(--color-cta);
                margin-left: 7px;
              }
              @media (max-width: 767px) {
                justify-content: center;
              }
            `}
          >
            {props.hidePhoneUnderButton && isPhoneHidden ? (
              <Button small withIcon greenish onClick={showPhone}>
                <PhoneIcon width="12" color="currentColor" />
                <span>{t("common:show_phone")}</span>
              </Button>
            ) : (
              <>
                <PhoneIcon width="12" color="currentColor" />
                <a href={`tel:${props.phone}`}>{props.phone}</a>
              </>
            )}
          </div>
        )}
        <div
          css={`
            @media (max-width: ${({ theme }) => theme.mobileBp}) {
              display: none;
            }
          `}
        >
          <Bio value={props.bio} placeholder={props.bioPlaceholder} />
        </div>
      </div>
      <div
        css={`
          @media (max-width: ${({ theme }) => theme.mobileBp}) {
            display: none;
          }
        `}
      >
        {props.contactsComponent}
      </div>
    </S.Wrap>
  );
};
Details.displayName = "ProfileDetails";
Details.propTypes = {
  address: PT.string,
  isPremium: PT.bool,
  pageType: PT.oneOf(["master", "client", "saloon"]).isRequired,
  isOwner: PT.bool.isRequired,
  rate: PT.number,
  reviewsCount: PT.number,
  bio: PT.string,
  address: PT.string,
  showPhone: PT.bool,
  hidePhoneUnderButton: PT.bool,
  phone: PT.string,

  openFreeSlots: PT.func,
  t: PT.func.isRequired,
};

export default memo(Details);
